(function () {
  var root = document.querySelector('.serum-subscription-usps--serum-sub, [data-serum-atc-pricing]');
  if (!root) return;

  var productInfo = root.closest('[data-product-info]') || document;
  var scheduled = false;

  function selectedBar() {
    return productInfo.querySelector('.kaching-bundles__bar--selected')
      || productInfo.querySelector('input[name^="kaching-bundles-deal"]:checked')?.closest('.kaching-bundles__bar');
  }

  function syncButtonPrice() {
    var button = productInfo.querySelector('form.product__form[data-product-form] [data-add-to-cart]');
    var bar = selectedBar();
    if (!button || !bar) return;

    var price = bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
    var compare = bar.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
    if (!price) return;

    button.closest('.product__submit__holder')?.classList.add('smooche-serum-sub-atc');
    var pill = button.querySelector('.smooche-serum-sub-atc__price');
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'smooche-serum-sub-atc__price';
      pill.innerHTML = '<span class="smooche-serum-sub-atc__compare"></span><span class="smooche-serum-sub-atc__current"></span>';
      var label = button.querySelector('[data-add-to-cart-text]');
      if (label) label.insertAdjacentElement('afterend', pill);
      else button.appendChild(pill);
    }

    var compareNode = pill.querySelector('.smooche-serum-sub-atc__compare');
    var currentNode = pill.querySelector('.smooche-serum-sub-atc__current');
    var showCompare = !!compare && compare !== price;
    if (compareNode.hidden === showCompare) compareNode.hidden = !showCompare;
    if (compareNode.textContent !== compare) compareNode.textContent = compare || '';
    if (currentNode.textContent !== price) currentNode.textContent = price;
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncButtonPrice();
    });
  }

  new MutationObserver(scheduleSync).observe(productInfo, {
    childList: true,
    characterData: true,
    subtree: true
  });
  productInfo.addEventListener('click', function (event) {
    if (event.target.closest('.kaching-bundles__bar')) scheduleSync();
  }, true);
  scheduleSync();
})();
